<template>
  <div>
    <v-row>
      <!-- <v-col cols="5">
        <div class="pa-3">
          <v-card class="pa-3" color="#CFD8DC" outlined>
            <v-img src="https://picsum.photos/510/300?random" aspect-ratio="1.7"></v-img>
            <div>
              <v-file-input multiple label="Pilih Foto"></v-file-input>
            </div>
            <div class="hint-img">
              Besar file: maksimum 10.000.000 bytes (10 Megabytes)
              <br />Ekstensi file yang diperbolehkan: .JPG .JPEG .PNG
            </div>
          </v-card>
          <div>
            <v-btn block class="my-2" tile outlined color="success">
              <v-icon left>fas fa-lock</v-icon>Ubah Kata Sandi
            </v-btn>
          </div>
        </div>
      </v-col>-->
      <v-col cols="3"></v-col>
      <v-col cols="3">
        <div class="pa-3 mt-1">
          <div class="ubah-data mb-8">Ubah Biodata Diri</div>
          <div class="my-4">Nama</div>
          <!-- <div class="my-4">Tanggal Lahir</div>
          <div class="my-4">Jenis Kelamin</div>-->

          <div class="ubah-data my-8">Ubah Kontak</div>
          <div class="my-4">Email</div>
          <div class="my-4">Nomor HP</div>
        </div>
      </v-col>
      <v-col cols="4">
        <div class="pa-3">
          <div class="mb-8" style="color : white;">.</div>
          <div class="my-4">
            {{ dataUser.nama }}
            <v-dialog v-model="edtNama" width="500">
              <template v-slot:activator="{ on }">
                <v-btn color="#8BC34A" text small dark v-on="on">ubah</v-btn>
              </template>

              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  Ubah Nama
                  <v-spacer></v-spacer>
                  <v-btn @click="edtNama = false" icon color="#90A4AE">
                    <v-icon>fas fa-times-circle</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text>
                  <div class="pa-2 mt-3">
                    <v-form v-model="valid" lazy-validation ref="nama">
                      <v-text-field required label="Nama" v-model="dataUser.nama"></v-text-field>
                    </v-form>
                  </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="ubahNama(dataUser.nama)">ubah</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <!-- <div class="my-4">03 September 1997</div>
          <div class="my-4">Laki - laki</div>-->
          <div class="my-8" style="color : white;">.</div>
          <div class="my-4">
            <b v-if="dataUser.email == null">Isi nomor HP anda</b>
            <b v-if="dataUser.email !=null">{{ dataUser.email }}</b>
            <v-dialog v-model="edtEmail" width="500">
              <template v-slot:activator="{ on }">
                <v-btn color="#8BC34A" text small dark v-on="on">Ubah</v-btn>
              </template>

              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  Ubah Email
                  <v-spacer></v-spacer>
                  <v-btn @click="edtEmail = false" icon color="#90A4AE">
                    <v-icon>fas fa-times-circle</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text>
                  <div class="pa-2 mt-3">
                    <v-form v-model="valid" lazy-validation ref="email">
                      <v-text-field required label="Email" v-model="dataUser.email"></v-text-field>
                    </v-form>
                  </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="ubahEmail(dataUser.email)">ubah</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <div class="my-4">
            <b v-if="dataUser.handphone == null">Isi nomor HP anda</b>
            <b v-if="dataUser.handphone !=null">{{ dataUser.handphone }}</b>
            <v-dialog v-model="edthp" width="500">
              <template v-slot:activator="{ on }">
                <v-btn color="#8BC34A" text small dark v-on="on">Ubah</v-btn>
              </template>

              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  Ubah Nomor HP
                  <v-spacer></v-spacer>
                  <v-btn @click="edthp = false" icon color="#90A4AE">
                    <v-icon>fas fa-times-circle</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text>
                  <div class="pa-2 mt-3">
                    <v-form v-model="valid" lazy-validation ref="nohp">
                      <v-text-field required v-model="dataUser.handphone" label="Nomor HP"></v-text-field>
                    </v-form>
                  </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="ubahHandphone(dataUser.handphone)">ubah</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      valid: true,
      overlay: false,
      dataUser: [],
      edtEmail: false,
      email: null,
      edtNama: false,
      nama: null,
      edthp: false,
      nohp: null,
      id: localStorage.getItem("user_id")
    };
  },
  mounted() {
    this.getDataUser();
  },

  methods: {
    getDataUser() {
      this.overlay = true;
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/ViewUser/" +
          localStorage.getItem("user_id")
      )
        .then(response => response.json())
        .then(data => {
          this.overlay = false;
          this.dataUser = data;
        });
    },
    ubahNama(data) {
      Swal.fire({
        title: "Ubah Profil",
        text: "Pastikan data anda sudah benar!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, lanjutkan!"
      }).then(result => {
        this.edtNama = false;
        this.overlay = true;
        if (result.value && this.$refs.nama.validate()) {
          fetch("http://meridinet.saebo.id:2082/Login/api/tabel/updusers", {
            method: "POST",
            body: JSON.stringify({
              user_id: this.id,
              nama: data
            }),
            headers: {
              "Content-type": "application/json"
            }
          })
            .then(response => response.json())
            .then(data => {
              this.overlay = false;
              console.log(data);
              Swal.fire("Sukses!", "Data berhasil diubah!", "success");
            });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Semua Kolom Wajib diisi"
          });
          this.overlay = false;
        }
      });
    },
    ubahEmail(data) {
      Swal.fire({
        title: "Ubah Profil",
        text: "Pastikan data anda sudah benar!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, lanjutkan!"
      }).then(result => {
        this.edtEmail = false;
        this.overlay = true;
        if (result.value && this.$refs.email.validate()) {
          fetch("http://meridinet.saebo.id:2082/Login/api/tabel/updusers", {
            method: "POST",
            body: JSON.stringify({
              user_id: this.id,

              email: data
            }),
            headers: {
              "Content-type": "application/json"
            }
          })
            .then(response => response.json())
            .then(data => {
              this.overlay = false;
              console.log(data);
              Swal.fire("Sukses!", "Data berhasil diubah!", "success");
            });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Semua Kolom Wajib diisi"
          });
          this.overlay = false;
        }
      });
    },
    ubahHandphone(data) {
      Swal.fire({
        title: "Ubah Profil",
        text: "Pastikan data anda sudah benar!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, lanjutkan!"
      }).then(result => {
        this.overlay = true;
        this.edthp = false;
        if (result.value && this.$refs.nohp.validate()) {
          fetch("http://meridinet.saebo.id:2082/Login/api/tabel/updusers", {
            method: "POST",
            body: JSON.stringify({
              user_id: this.id,

              nohp: data
            }),
            headers: {
              "Content-type": "application/json"
            }
          })
            .then(response => response.json())
            .then(data => {
              this.overlay = false;
              console.log(data);
              Swal.fire("Sukses!", "Data berhasil diubah!", "success");
            });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Semua Kolom Wajib diisi"
          });
          this.overlay = false;
        }
      });
    }
  }
};
</script>
<style scoped>
.hint-img {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  letter-spacing: -0.1px;
  word-spacing: 2px;
  color: #868686;
  font-weight: normal;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.ubah-data {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 100%;
  letter-spacing: 0px;
  word-spacing: 0px;
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
</style>
